// src/pages/NotFound.js

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NotFound.css'; // Optional: Include CSS for styling

const NotFound = () => {
  const { t } = useTranslation("screens.NotFound");

  return (
    <div className="not-found">
      <h1>404</h1>
      <p>{t('title')}</p>
      <Link to="/">{t('actions.goHome')}</Link>
    </div>
  );
};

export default NotFound;
